import { useState, useEffect, useContext, useRef } from 'react';
import { DbContext } from '../../App.js';
import { SortableContext } from '../../App.js';

import generateUUID from '../../util/UUIDUtils.js';

import TaskNode from '../../models/TaskNode.js'

import ItemClass from '../../models/ItemClass.js';

import Arrow from '../Arrow.js';

import './ListItem.css'

import DatePickerComponent from '../DatePicker.js';
// import { Checkbox } from '@mui/material';

import {useSortable} from '@dnd-kit/react/sortable';

import { Checkbox } from 'pretty-checkbox-react';

import '@djthoms/pretty-checkbox';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import DragHandle from '../DragHandle.js';


export default function ListItem ({ taskNode, deleteTask, onDragFinished, active }) {

    const db = useContext(DbContext);

    const [showMenu, setShowMenu] = useState(false)

    const itemRef = useRef(null)

    useEffect(() => {
        setNode(taskNode)

        document.addEventListener('mousedown', () => {
            // console.log("document level click")
            setShowMenu(false)
        })


    }, [taskNode])

    const [node, setNode] = useState(taskNode)
    const [task, setTask] = useState(taskNode.value)


    const sortable = useSortable({
        id: task.id,
        index: task.sortOrder,
        group: task.parentId ?? "root"
      });


    

    // console.log(listeners);

    

    const [taskText, setTaskText] = useState(task.data)
    const [isExpanded, setIsExpanded] = useState(task.isExpanded ?? false);

    const [menuPosition, setMenuPosition] = useState({ xPos: 0, yPos: 0 });

    const [showCalendar, setShowCalendar] = useState(false)

    const [deadlineDate, setDeadlineDate] = useState(task.deadlineDate)
 
    const handleCheckboxChange = (event) => {
        // Logic to handle checkbox change

        event.stopPropagation()

        const tasksObjectStore = db.db
                .transaction("tasks", "readwrite")
                .objectStore("tasks");

        const changeCompletion = new Promise((resolve, reject) => {
            
            const existingTaskRequest = tasksObjectStore.get(task.id)

            existingTaskRequest.onsuccess = (event) => {
                resolve(event.target.result)
            }

        }).then((existingTask) => {

            existingTask.isCompleted = !isCompleted

            const requestUpdate = tasksObjectStore.put(existingTask);

            requestUpdate.onsuccess = () => {
                setIsCompleted(!isCompleted)
            }
            
            requestUpdate.onerror = (event) => {
                console.log(event)
            }
        }) 
    };

    const handleTextChange = (event) => {
        // Logic to handle text change

        // console.log(event)

        if (event.key === 'Enter' || event.code === 'Enter') {
            saveText();
            event.preventDefault();
        }
    };

    const handleFocusOut = () => {
        saveText();
    }

    function saveText() {
        const tasksObjectStore = db.db.transaction("tasks", "readwrite").objectStore("tasks");

            const existingTaskRequest = tasksObjectStore.get(task.id)
            existingTaskRequest.onsuccess = (event) => {
                const existingTask = event.target.result;

                if (existingTask === undefined)
                    return;

                existingTask.data = taskText;
                const requestUpdate = tasksObjectStore.put(existingTask);

                requestUpdate.onsuccess = () => {
                    console.log("update success")
                }
            }

            existingTaskRequest.onerror = (event) => {
                console.log(event)
            }
    } 

    const handleExpandCollapse = (event) => {
        // Logic to handle double click

        const store = db.db.transaction("tasks", "readwrite").objectStore("tasks")

        task.isExpanded = !isExpanded

        store.put(task).onsuccess = () => {
            setIsExpanded(!isExpanded)
        }
    };

    const handleRightClick = (event) => {
        event.preventDefault()
        setShowMenu(true)
        setMenuPosition({xPos: event.clientX, yPos: event.clientY})

    }

    const handleDeleteClick = (event) => {
        // Logic to handle delete click

        const tasksObjectStore = db.db.transaction("tasks", "readwrite").objectStore("tasks")
        const tagIndex = tasksObjectStore.index("parentId")
        tasksObjectStore.delete(task.id);
        var pdestroy = tagIndex.openKeyCursor(); 
        pdestroy.onsuccess = function(event) {
            deleteTask(task.id)
            const cursor = event.target.result;
            if (cursor) {

                if(cursor.key === task.id) {
                    console.log(cursor.key)
                    tasksObjectStore.delete(cursor.primaryKey);

                }
                cursor.continue();
            }
        }
    };

    const handleAddSubTaskDoubleClick = (event) => {
        event.stopPropagation();
    }

    const handleAddSubTaskClick = (event) => {
        // Logic to handle add subtask click

        const subTask = new ItemClass(generateUUID(), task.id, "Sub Task", node.children.length )

        taskNode.addChild(new TaskNode(subTask))
        setNode(new TaskNode(taskNode.value, taskNode.children))

        const store = db.db.transaction("tasks", "readwrite").objectStore("tasks");

        store.add(subTask)

        store.transaction.oncomplete = () => {
            // console.log("sub task added")
        }
    };

    const handleMenuItemClick = (menu) => {

        // console.log(menu)

        if (menu === 'addSubTask') {
            handleAddSubTaskClick()
            setShowMenu(false)
        }
        else if (menu === "delete") {
            handleDeleteClick()
            setShowMenu(false)
        }
        else if (menu === "check") {
            console.log(task.id)
            setShowMenu(false)
        }
        else if(menu === "addDueDate") {
            setShowMenu(false)
            setShowCalendar(true)
        }
    }

    const setDeadline = (dateData) => {
    

        const tasksObjectStore = db.db.transaction("tasks", "readwrite").objectStore("tasks")

        task.deadlineDate = dateData.$d

        tasksObjectStore.put(task).onsuccess = () => {
            // setDeadlineDate(`${dateData.$D}/${(dateData.$M) + 1}/${dateData.$y}`)
            setDeadlineDate(dateData.$d)
            setShowCalendar(false)
        }
    }


    const [isCompleted, setIsCompleted] = useState(task.isCompleted)

    

    const items = node.children.map ((element) => <ListItem 
        key = {element.value.id } 
        taskNode={element} 
        deleteTask={(taskId) => {
            setNode(new TaskNode(node.value, node.children.filter((value) => value.value.id !== taskId )))
        }} 
        active={active}
        // onDragFinished={onDragFinished}
        />)


    

    return (
        
        <div className="list-item-container" ref={itemRef} id={task.id} draggable={false}  >
            <div className="list-item" onContextMenu={handleRightClick} onBlur={handleFocusOut} data-id={task.id} >
                <Arrow onClick={handleExpandCollapse} doesHaveChildren = { node.children.length > 0 } isExpanded = {isExpanded && !(active === task.id)}/>
                <DragHandle id={task.id}/>
                <Checkbox className="list-item-checkbox" checked={isCompleted} style={{marginRight: '2px', marginLeft: '2px'}} shape="curve" variant="fill" animation="smooth" icon={<span className="material-icons" style={{ verticalAlign: 'middle' }}>check</span>} onChange={handleCheckboxChange} ></Checkbox>
                {/* <input type="checkbox" className="list-item-checkbox" checked={isCompleted} onChange={handleCheckboxChange} />                 */}
                <span className='list-item-text-area'>
                    <p suppressContentEditableWarning contentEditable={true} spellCheck={false} style = {{textDecoration: isCompleted? 'line-through' : 'none', display: 'inline'}} className="list-item-text" onKeyDown={handleTextChange} onInput={(event) => setTaskText(event.target.textContent) }>{task.data}</p>
                    <span className='list-item-due-date' style={{visibility: deadlineDate === null? 'hidden': 'visible'}}><DueDate date={deadlineDate}/></span>
                    {/* <span className="list-item-add-subtask" onClick={handleAddSubTaskClick} onDoubleClick={handleAddSubTaskDoubleClick}><img src={plus} alt="Add Subtask" /></span> */}
                </span>
                <DatePickerComponent shouldShow = {showCalendar} onDateChange={setDeadline}/>
                {/* <span className="list-item-delete"><DatePickerComponent/></span> */}
                {/* <span className="list-item-delete" onClick={handleDeleteClick}><img src={trash} alt="Delete"/> </span> */}
            </div>
            {/* <DndContext sensors={sensors} collisionDetection={closestCenter}> */}
                <SubTasksHolder id={task.id} subTasks={items} isExpanded={isExpanded && !(active === task.id)}/>
            {/* </DndContext> */}
            <ContextMenu 
                xPos={menuPosition.xPos}
                yPos={menuPosition.yPos}
                showMenu={showMenu}
                onMenuItemClick={handleMenuItemClick}
            />
        </div>
    );
};

const SubTasksHolder = ({id, subTasks, isExpanded}) => {

    // const {isOver, setNodeRef} = useSortable({
    //     id: id,
    // });

    return (<div className="list-item-child-holder"  style={{ display: isExpanded ? 'block' : 'none' , marginLeft: '20px'}} >
        {subTasks}
    </div>);

}

const DueDate = ({date}) => {

    if (date !== null) {

        const d = date;
        const m = d.getMonth();
        const ds = `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`

        return <span>
                <p style={{display: 'inline'}}>
                    {ds}
                </p>
            </span>
    }
}


const ContextMenu = ({ xPos, yPos, showMenu, onMenuItemClick }) => {
    if (!showMenu) {
      return <div></div>;
    }
  
    return (
      <ul
        style={{
          display: showMenu ? 'block' : 'none',
          position: 'absolute',
          top: `${yPos}px`,
          left: `${xPos}px`,
          backgroundColor: 'white',
          border: '1px solid black',
          listStyleType: 'none',
          padding: 0,
          margin: 0,
          zIndex: 999,
          boxShadow: '0px 0px 10px rgba(0,0,0,0.5)'
        }}
      >
        <li onMouseDown={() => onMenuItemClick('delete')} style={{ padding: '8px', cursor: 'pointer' }}>Delete</li>
        <li onMouseDown={() => onMenuItemClick('addSubTask')} style={{ padding: '8px', cursor: 'pointer' }}>Add Sub Task</li>
        <li onMouseDown={() => onMenuItemClick('addDueDate')} style={{ padding: '8px', cursor: 'pointer' }}>Add Due Date</li>
      </ul>
    );
};